import {createWebHistory , createRouter} from "vue-router";
import allBlogs from '../components/allBlogs'
import Master from '../Master/master'
import BlogRead from '../components/blog_read'
const routes = [
    {
        path : '/all_blogs',
        name : 'Blogs',
        component : allBlogs
    },
    {
        path : '/',
        name : 'Master',
        component : Master
    },
    {
        path : '/laravel/read',
        name : 'blog_read',
        component : BlogRead
    }
]

const router = createRouter({
    history : createWebHistory('/portfolio/'),
    routes
})
export default router;